import React from 'react';
import { RequestContainer } from './styledRequestComponents'
import RequestPost from './RequestPost'
const EditCard = (props) => {
  return (
    <RequestContainer>
      <RequestPost />
    </RequestContainer>
  );
};

export default EditCard;